import { connect } from 'react-redux';

import GraficaVentasCostos from './GraficaVentasCostos';
import { actions } from "../../../../../redux/modules/reportes/ventas_costos";

const ms2p = (state) => {
    return {
        ...state.reporte_ventas_costos,
        pais: state.usuario.me.pais
    };
};

const md2p = {
    ...actions
};

export default connect(ms2p, md2p)(GraficaVentasCostos);
